/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AptosDefiProjectDetailRequest } from '../models/AptosDefiProjectDetailRequest';
import type { AptosDefiProtocolListRequest } from '../models/AptosDefiProtocolListRequest';
import type { AptosPoolListInfo } from '../models/AptosPoolListInfo';
import type { AptosPoolRequest } from '../models/AptosPoolRequest';
import type { CommonDefiTvlChartInfo } from '../models/CommonDefiTvlChartInfo';
import type { CommonEmptyRequest } from '../models/CommonEmptyRequest';
import type { DefiProjectDetailInfo } from '../models/DefiProjectDetailInfo';
import type { DefiRequest } from '../models/DefiRequest';
import type { ProtocolCategoryListInfo } from '../models/ProtocolCategoryListInfo';
import type { ProtocolListInfo } from '../models/ProtocolListInfo';
import type { SomniaDefiProjectDetailRequest } from '../models/SomniaDefiProjectDetailRequest';
import type { SomniaDefiProtocolListRequest } from '../models/SomniaDefiProtocolListRequest';
import type { SomniaProtocolListInfo } from '../models/SomniaProtocolListInfo';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class DefiControllerService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getProtocolList({
        requestBody,
    }: {
        requestBody: (AptosDefiProtocolListRequest | SomniaDefiProtocolListRequest),
    }): CancelablePromise<(ProtocolListInfo | SomniaProtocolListInfo)> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/defi/protocol/list',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getProtocolCategoryList({
        requestBody,
    }: {
        requestBody: DefiRequest,
    }): CancelablePromise<ProtocolCategoryListInfo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/defi/protocol/category/list',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getProjectDetail({
        requestBody,
    }: {
        requestBody: (AptosDefiProjectDetailRequest | SomniaDefiProjectDetailRequest),
    }): CancelablePromise<DefiProjectDetailInfo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/defi/project',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getPoolList({
        requestBody,
    }: {
        requestBody: AptosPoolRequest,
    }): CancelablePromise<AptosPoolListInfo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/defi/pool/list',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getTvlChartInfo({
        requestBody,
    }: {
        requestBody: CommonEmptyRequest,
    }): CancelablePromise<CommonDefiTvlChartInfo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/defi/chart/tvl',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

}
